import React, {useEffect, useState} from "react";
import {useToasts} from "react-toast-notifications";
import restService from "../../../../services/restService";
import Input from "../../../../components/common/Input";

const keys = [
  "minimum_threshold_amount",
  "maximum_threshold_amount",
  "fixed_charge_amount",
  "percentage_charge_amount",
  "destination_currency",
  "source_currency",
];
const UpdateCharge = ({charge, onSubmit, initCallback, setChargeToUpdate}) => {
  const {addToast} = useToasts();

  const [form, setForm] = useState(charge);
  const [confirmation, setConfirmation] = useState(false);
  const [errors, setErrors] = useState({});
  const [currencies, setCurrencies] = useState([]);
  const [agents, setAgents] = useState([]);
  const [agencies, setAgencies] = useState([]);
  const [callback, setCallback] = useState(() => {});

  const initFormValues = async () => {
    let details = {};
    const agencyList = await restService.AgencyApi.getAgencies();
    const agentList = await restService.AgentApi.getAgentsByAgency(
      charge.agency.id
    );
    const countryList = await restService.UtilsApi.getCountries();
    const currencies = countryList?.data?.data?.map((c) => {
      return c.currency_code;
    });
    setCurrencies(currencies);
    setAgents(agentList.data?.data?.data);
    setAgencies(agencyList.data?.data?.data);

    setForm({...form, agency_id: charge.agency.id, agent_id: charge.agent.id});
  };

  useEffect(() => {
    initFormValues();
  }, []);
  useEffect(() => {
    initCallback(saveCharge);
  }, [form]);

  const validateForm = () => {
    let errorList = {...errors};
    keys.forEach((key) => {
      if (!form[key]) {
        errorList[key] = "This field is required.";
      }
    });
    setErrors(errorList);
    return Object.keys(errorList).length === 0;
  };

  const saveCharge = () => {
    if (validateForm()) {
      // Normalize missing fields to 0 to satisfy backend validation
      const payload = {
        ...form,
        fixed_charge_amount: Number(form?.fixed_charge_amount ?? 0) || 0,
        percentage_charge_amount: Number(form?.percentage_charge_amount ?? 0) || 0,
      };

      restService.ChargesApi.updateCharge(payload).then((response) => {
        onSubmit();
      });
    }
  };

  const onFormChange = ({target}) => {
    let details = {...form};
    details[target.name] = target.value;

    if (target.name === "agency_id") {
      restService.AgentApi.getAgentsByAgency(target.value).then(({data}) => {
        setAgents(data?.data.data);
        setForm({...details, agent_id: data?.data?.data[0]?.id});
      });

      let errorList = {...errors};
      delete errorList["agent_id"];
    }
    setForm(details);

    let errorList = errors;
    delete errorList[target.name];
    setErrors(errorList);
  };

  return (
    // <div className="intro-y box py-10 sm:py-20 mt-5">
    //     <div className="px-5 mt-10">
    //         <div className="font-medium text-center text-lg">Update Charge</div>
    //         <div className="text-gray-600 text-center mt-2">Please enter the charge details.
    //         </div>
    //     </div>
    //     <div className="px-5 sm:px-20 mt-10 pt-10 border-t border-gray-200 dark:border-dark-5">
    //         <div className="mt-5">
    //             <div className="grid grid-cols-12 gap-4 gap-y-5 ">
    //                 <div className="intro-y col-span-12 sm:col-span-6">
    //                     <label htmlFor="input-wizard-1" className="form-label">Minimum Threshold Amount *</label>
    //                     <input type="number" min={0} value={form.minimum_threshold_amount} onChange={onFormChange} name="minimum_threshold_amount" className="form-control" placeholder="13.20"/>
    //                     <p className="text-red-500 text-xs italic pt-1">{errors.minimum_threshold_amount}</p>
    //                 </div>
    //                 <div className="intro-y col-span-12 sm:col-span-6">
    //                     <label htmlFor="input-wizard-1" className="form-label">Maximum Threshold Amount *</label>
    //                     <input type="number" min={0} value={form.maximum_threshold_amount} onChange={onFormChange} name="maximum_threshold_amount" className="form-control" placeholder="43.20"/>
    //                     <p className="text-red-500 text-xs italic pt-1">{errors.maximum_threshold_amount}</p>
    //                 </div>
    //                 <div className="intro-y col-span-12 sm:col-span-6">
    //                     <label htmlFor="input-wizard-1" className="form-label">Fixed Charge Amount {!form.percentage_charge_amount?"*" : ""}</label>
    //                     <input type="number" min={0} value={form.fixed_charge_amount} onChange={onFormChange} name="fixed_charge_amount" className="form-control" placeholder="23.20"/>
    //                     <p className="text-red-500 text-xs italic pt-1">{errors.fixed_charge_amount}</p>
    //                 </div>
    //                 <div className="intro-y col-span-12 sm:col-span-6">
    //                     <label htmlFor="input-wizard-1" className="form-label">Percentage Charge Amount{!form.fixed_charge_amount?"*" : ""}</label>
    //                     <input type="number" min={0} max={100} value={form.percentage_charge_amount} onChange={onFormChange} name="percentage_charge_amount" className="form-control" placeholder="13.20"/>
    //                     <p className="text-red-500 text-xs italic pt-1">{errors.percentage_charge_amount}</p>
    //                 </div>
    //                 <div className="intro-y col-span-12 sm:col-span-6">
    //                     <label htmlFor="input-wizard-5" className="form-label">Agency</label>
    //                     <select id="input-wizard-6" value={form.agency_id} onChange={onFormChange} name="agency_id" className="form-select">
    //                         <option value="">None</option>
    //                         {agencies.map(agency => {
    //                             return <option value={agency.id}>{agency.name}</option>
    //                         })}
    //                     </select>
    //                     <p className="text-red-500 text-xs italic pt-1">{errors.agency_id}</p>

    //                 </div>
    //                 <div className="intro-y col-span-12 sm:col-span-6">
    //                     <label htmlFor="input-wizard-5" className="form-label">Agent</label>
    //                     <select id="input-wizard-6" value={form.agent_id} onChange={onFormChange} name="agent_id" className="form-select">
    //                         <option value="">None</option>
    //                         {agents.map(agent => {
    //                             return <option value={agent.id}>{agent.firstname} {agent.lastname}</option>
    //                         })}
    //                     </select>
    //                     <p className="text-red-500 text-xs italic pt-1">{errors.agent_id}</p>

    //                 </div>
    //                 <div className="intro-y col-span-12 sm:col-span-6">
    //                     <label htmlFor="input-wizard-5" className="form-label">Source Currency</label>
    //                     <select id="input-wizard-6" value={form.source_currency} onChange={onFormChange} name="source_currency" className="form-select">
    //                         {currencies.map(currency => {
    //                             return <option value={currency}>{currency}</option>
    //                         })}
    //                     </select>
    //                 </div>
    //                 <div className="intro-y col-span-12 sm:col-span-6">
    //                     <label htmlFor="input-wizard-5" className="form-label">Destination Currency</label>
    //                     <select id="input-wizard-6" value={form.destination_currency} onChange={onFormChange} name="destination_currency" className="form-select">
    //                         {currencies.map(currency => {
    //                             return <option value={currency}>{currency}</option>
    //                         })}
    //                     </select>
    //                 </div>

    //             </div>
    //         </div>
    //     </div>
    // </div>

    <div className="flex intro-y flex-col items-center md:gap-8 gap-6 justify-center py-8 px-8">
      {/* Modern Header */}
      <div className="flex items-start justify-between w-full">
        <div className="flex items-center gap-4">
          <div className="p-3 bg-gradient-to-r from-green-100 to-emerald-100 rounded-xl">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="text-green-600">
              <rect x="1" y="3" width="15" height="13" />
              <path d="M16 8h4a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2h-4" />
              <circle cx="9" cy="9" r="2" />
              <path d="M8 21l5-11 5 11" />
            </svg>
          </div>
          <div className="flex flex-col gap-1">
            <h1 className="text-2xl font-bold text-gray-900">Update Charge Configuration</h1>
            <p className="text-sm text-gray-600">
              Modify the charge configuration details
            </p>
          </div>
        </div>

        <button
          onClick={() => setChargeToUpdate(undefined)}
          className="p-2 rounded-xl text-gray-400 hover:text-gray-600 hover:bg-gray-100 transition-all border-none bg-transparent cursor-pointer"
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M18 6 6 18" />
            <path d="M6 6l12 12" />
          </svg>
        </button>
      </div>

      <div className="grid w-full md:max-w-[80%] md:grid-cols-2 gap-4 grid-cols-1">
        <div className="flex flex-col gap-1">
          <Input
            containerStyle={"w-full md:w-auto"}
            type="number"
            min={0}
            value={form.minimum_threshold_amount}
            onChange={onFormChange}
            name="minimum_threshold_amount"
            className="form-control"
            placeholder="13.20"
            labelName={"Minimum Threshold Percentage*"}
          />

          <p className="text-red-500 text-xs italic pt-1">
            {errors?.minimum_threshold_amount}
          </p>
        </div>

        <div className="flex flex-col gap-1">
          <Input
            containerStyle={"w-full md:w-auto"}
            type="number"
            min={0}
            value={form.maximum_threshold_amount}
            onChange={onFormChange}
            name="maximum_threshold_amount"
            className="form-control"
            placeholder="43.20"
            labelName={"Maximum Threshold Percentage*"}
          />
          <p className="text-red-500 text-xs italic pt-1">
            {errors?.maximum_threshold_amount}
          </p>
        </div>
        <div className="flex flex-col gap-1">
          <Input
            containerStyle={"w-full md:w-auto"}
            type="number"
            min={0}
            value={form.fixed_charge_amount}
            onChange={onFormChange}
            name="fixed_charge_amount"
            className="form-control"
            placeholder="23.20"
            labelName={"Fixed Charge Amount"}
          />
          <p className="text-red-500 text-xs italic pt-1">
            {errors.fixed_charge_amount}
          </p>
        </div>

        <div className="flex flex-col gap-1">
          <Input
            containerStyle={"w-full md:w-auto"}
            type="number"
            min={0}
            max={100}
            value={form?.percentage_charge_amount}
            onChange={onFormChange}
            name="percentage_charge_amount"
            className="form-control"
            placeholder="13.20"
            labelName={"Percentage Charge Amount*"}
          />
          <p className="text-red-500 text-xs italic pt-1">
            {errors?.percentage_charge_amount}
          </p>
        </div>
        <div className="flex flex-col gap-1">
          <label htmlFor="input-wizard-5" className="form-label mb-0 text-xs">
            Agency
          </label>
          <select
            id="custom-form-select"
            value={form.agency_id}
            onChange={onFormChange}
            name="agency_id"
            className="form-select"
          >
            <option value="">None</option>{" "}
            {agencies.map((agency) => {
              return <option value={agency.id}>{agency.name}</option>;
            })}
          </select>
          <p className="text-red-500 text-xs italic pt-1">
            {errors?.agency_id}
          </p>
        </div>
        <div className="flex flex-col gap-1">
          <label htmlFor="input-wizard-5" className="form-label mb-0 text-xs">
            Agent
          </label>
          <select
            id="custom-form-select"
            value={form.agent_id}
            onChange={onFormChange}
            name="agent_id"
            className="form-select"
          >
            <option value="">None</option>
            {agents.map((agent) => {
              return (
                <option value={agent.id}>
                  {agent?.firstname} {agent?.lastname}
                </option>
              );
            })}
          </select>
          <p className="text-red-500 text-xs italic pt-1">{errors?.agent_id}</p>
        </div>
        <div className="flex flex-col gap-1">
          <label htmlFor="input-wizard-5" className="form-label mb-0 text-xs">
            Source Currency
          </label>
          <select
            id="custom-form-select"
            value={form.source_currency}
            onChange={onFormChange}
            name="source_currency"
            className="form-select"
          >
            {" "}
            {currencies.map((currency) => {
              return <option value={currency}>{currency}</option>;
            })}
          </select>
          <p className="text-red-500 text-xs italic pt-1">{errors.agency_id}</p>
        </div>
        <div className="flex flex-col gap-1">
          <label htmlFor="input-wizard-5" className="form-label mb-0 text-xs">
            Destination Currency
          </label>
          <select
            id="custom-form-select"
            value={form.destination_currency}
            onChange={onFormChange}
            name="destination_currency"
            className="form-select"
          >
            {currencies.map((currency) => {
              return <option value={currency}>{currency}</option>;
            })}
          </select>
          <p className="text-red-500 text-xs italic pt-1 text-center">
            {errors?.destination_currency}
          </p>
        </div>
      </div>

      {/* Modern Action Buttons */}
      <div className="flex items-center gap-4">
        <button
          onClick={() => setChargeToUpdate(undefined)}
          className="px-6 py-3 rounded-xl font-semibold text-sm cursor-pointer transition-all border border-gray-300 bg-white text-gray-700 hover:bg-gray-50 shadow-md flex items-center gap-2"
        >
          Cancel
        </button>
        <button 
          onClick={() => saveCharge()} 
          className="px-6 py-3 rounded-xl font-semibold text-sm cursor-pointer transition-all border-none bg-gradient-to-r from-green-600 to-emerald-600 text-white hover:from-green-700 hover:to-emerald-700 shadow-lg flex items-center gap-2"
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
            <path d="M22 4 12 14.01l-3-3" />
          </svg>
          Update Charge
        </button>
      </div>
    </div>
  );
};

export default UpdateCharge;
